import { gql } from 'graphql-tag'
import { settingsFragment } from '../../admin/station/stationSettings/settingsQueries'

export const fetchReportMonthlyCustomerSales = gql`
  query fetchReportMonthlyCustomerSales($stationId: ID!, $type: ProductType!, $year: Int!, $month: Int!) {
    reportMonthlyCustomerSales(stationId: $stationId, type: $type, year: $year, month: $month) {
      week
      date
      stationId
      type
      notes
      salesVolume
      salesAmount
      target
    }
    stationSettings(stationId: $stationId) {
      ...SettingsFragment
    }
  }
  ${settingsFragment}
`
